import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import TransfersTable from "./components/TransfersTable";
import OrgCompanySelector, { isOrgAdmin } from "../../../components/orgCompanySelector/OrgCompanySelector";

export default function Transfers() {
    const [selectedCompanyId, setSelectedCompanyId] = React.useState(null);
    const showOrgSelector = isOrgAdmin();

    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            {showOrgSelector && (
                <Flex mb="16px" px="10px">
                    <OrgCompanySelector
                        selectedCompanyId={selectedCompanyId}
                        onChange={setSelectedCompanyId}
                    />
                </Flex>
            )}
            <TransfersTable selectedCompanyId={selectedCompanyId} />
        </Box>
    );
}
